import { Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const JobDescriptionControl = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end">
        <Typography
          textAlign="end"
          variant="secondary"
          sx={{ paddingTop: "4px" }}
        >
          {t("workHistory:jobDescription")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="jobDescription"
          control={control}
          render={({ field: { name, value, onChange } }) => (
            <TextField
              multiline
              rows={4}
              autoComplete="off"
              fullWidth
              required
              name={name}
              size="small"
              value={value}
              onChange={onChange}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default JobDescriptionControl;
